import React from "react";
import { LoaderCircle, LoaderWrapper } from "./LoaderElements";

const Loader = () => {
  return (
    <LoaderWrapper>
      <LoaderCircle />
    </LoaderWrapper>
  );
};

export default Loader;
